import React from 'react';
const Header = () => {
  return <div className="bg-gradient-to-r from-gray-800 to-gray-900 text-white py-10 px-6 text-center" data-id="element-14">
      <h1 className="text-4xl md:text-5xl font-bold mb-3 drop-shadow-md" data-id="element-15">
        🌿 Five-Element Body Type Assessment
      </h1>
      <p className="text-xl opacity-90 max-w-2xl mx-auto" data-id="element-16">
        Discover your constitutional type according to Traditional Chinese
        Medicine wisdom
      </p>
    </div>;
};
export default Header;